<template>
    <div class="container">
        <h2 class="mb-0 font-active for_mobile text-center">Shop By Shape</h2>

        <div class="main-content">
            <div class="img_box">
                <div class="img_box_mod">

                    <div class="">
                        <picture>
                            <source media="(max-width: 767px)" width="610" height="350" srcset="/shopshape/band.webp" />
                            <img width="610" height="300" src="/shopshape/band.png" />
                        </picture>
                    </div>
                    <div class="diamond_box" :class="{ active: activeShape === key }" v-for="(shape, key) in shapes" :key="key">
                        <!-- Active Shape Image -->
                        <picture v-if="activeShape === key">
                            <source media="(max-width: 767px)" width="610" height="350" :src="shape.imgUrl" />
                            <img width="610" height="300" :src="shape.imgUrl" :alt="shape.name" />
                        </picture>
                        
                      
                    </div>

                </div>
            </div>

            <div class="textbox">
                <h2 class="font-active for_desktop">Shop By Shape</h2>
                <div class="info_box" :class="{ active: activeShape }" :key="activeShape">
                    <h3 class="font-active">{{ currentShape.name }} Cut</h3>
                    <p>{{ currentShape.description }}</p>
                </div>
                <!-- :class="{ active: activeShape === key }" v-for="(link, key) in shapes" :key="key" -->
                <div class="banner_btn">
                    <NuxtLink class="anker radious_four" :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: currentShape.link }})">Create your own
                    </NuxtLink>
                    <NuxtLink 
                        class="anker radious_four" 
                        :to="localePath({ name: 'preset-listing', query: currentShape.predesigned ? { 'Shape': currentShape.predesigned, 'RefreshKey':  currentShape.predesigned}:{} })">
                        Shop pre-designed
                    </NuxtLink>
                </div>
            </div>

            <div class="shape_main">
                <EngagementLandingShapeSlider :activeShape="activeShape" @shapeSelected="selectShape"/>
            </div>

        </div>

    </div>

</template>

<script setup>
    const localePath = useLocalePath();

    const shapes = {
        round: {
            name: 'Round',
            imgUrl: '/shopshape/round.png',
            description: 'Brilliant round cuts have the most brilliance. They have perfect symmetry and disperse maximum light, making them the most desired diamond shape of all.',
            active: true,
            link : 'round-rings',
            predesigned : 'Round',
        },
        oval: {
            name: 'Oval',
            imgUrl: '/shopshape/oval.png',
            description: 'Oval cuts are elongated variants of brilliant round cuts. They capture the same sparkle as round cuts and make an elegant yet out-of-the-box cut that gives the wearers finger more length. Currently, they are the most trending shape of the year.',
            active: false,
            link : 'oval-rings',
            predesigned : 'Oval',
        },
        princess: {
            name: 'Princess',
            imgUrl: '/shopshape/princess.png',
            description: 'Princess cuts have modern, geometrically designed diamonds that produce abundant sparkle. They are less expensive than brilliant round cuts and should be paired with channel or four prong settings for protection.',
            active: false,
            link : 'princess-rings',
            predesigned : 'Princess', 
        },
        cushion: {
            name: 'Cushion',
            imgUrl: '/shopshape/cushion.png',
            description: 'Cushion cuts have exquisite square cut diamonds with rounded corners. They exude an old-world charm, have exceptional sparkle, and match perfectly with vintage designs.',
            active: false,
            link : 'cushion-rings',
            predesigned : 'Cushion',
        },
        emerald: {
            name: 'Emerald',
            imgUrl: '/shopshape/emerald.png',
            description: 'Emerald cuts are rectangular step cut gems reminiscent of the 1920s and 1930s Art Deco Era. While these may not have an outstanding sparkle, this shape captures the gems clarity and light in an enthralling fashion.',
            active: false,
            link : 'emerald-rings',
            predesigned : 'Emerald',
        },
        heart: {
            name: 'Heart',
            imgUrl: '/shopshape/heart.png',
            description: 'Heart cuts are feminine, heart-shaped diamonds that are a modified version of the brilliant round cut. This diamond shape is an absolute symbol of love and has exceptional symmetry and brilliance, giving it a spectacular shine.',
            active: false,
            link : 'heart-rings',
            predesigned : 'Heart',
        },
        marquise: {
            name: 'Marquise',
            imgUrl: '/shopshape/marquise.png',
            description: 'Emerald cuts are rectangular step cut gems reminiscent of the 1920s and 1930s Art Deco Era. While these may not have an outstanding sparkle, this shape captures the gems clarity and light in an enthralling fashion.',
            active: false,
            link : 'marquise-rings',
            predesigned : 'Marquise', 
        },
        asscher: {
            name: 'Asscher',
            imgUrl: '/shopshape/asscher.png',
            description: 'Asscher cut diamonds come in square with layered facets of unique symmetry and geometric designs. This cut displays beautiful radiance and sparkle and is an ode to the fashion statement of Art Deco period.',
            active: false,
            link : 'asscher-rings ',
            predesigned : '', 
        },
        radiant: {
            name: 'Radiant',
            imgUrl: '/shopshape/radiant.png',
            description: 'Radiant cuts are similar to emerald cuts. The only difference is that radiant cut diamonds have unique, deeper-cut facets that give the diamond more sparkle.',
            active: false,
            link : 'radiant-rings',
            predesigned : 'Radiant',
        },
        pear: {
            name: 'Pear',
            imgUrl: '/shopshape/pear.png',
            description: 'Pear cuts, also known as teardrops, are hybrids of the oval and marquise cuts. They are perfect for vintage-inspired rings but also pair well with modern-day designs. Choosing a bezel or half-v ring setting gives maximum protection to your pear diamond.',
            active: false,
            link : 'pear-rings',
            predesigned : 'Pear', 
        }
    };
    // :to="localePath({ name:'preset-listing', query:{ 'Shape': 'Round', 'RefreshKey': 'Round'} })"
    // :to="localePath({ name:'preset-listing', query:{ 'Shape': 'Oval', 'RefreshKey': 'Oval'} })"
    // :to="localePath({ name:'preset-listing', query:{ 'Shape': 'Princess', 'RefreshKey': 'Princess'} })"
    // :to="localePath({ name:'preset-listing', query:{ 'Shape': 'Emerald', 'RefreshKey': 'Emerald' } })"
    // :to="localePath({ name:'preset-listing', query:{ 'Shape': 'Cushion', 'RefreshKey': 'cushion'} })"
    // :to="localePath({ name:'preset-listing', query:{ 'Shape': 'Heart', 'RefreshKey': 'heart'} })"
    // :to="localePath({ name:'preset-listing', query:{ 'Shape': 'Marquise', 'RefreshKey': 'marquise'} })"
    // :to="localePath({ name:'preset-listing', query:{ 'Shape': 'Asscher', 'RefreshKey': 'asscher'} })"
    // :to="localePath({ name:'preset-listing', query:{ 'Shape': 'Radiant', 'RefreshKey': 'radiant'} })"
    // :to="localePath({ name:'preset-listing', query:{ 'Shape': 'Pear', 'RefreshKey': 'pear'} })"
    const activeShape = ref('round');
    const currentShape = computed(() => shapes[activeShape.value]);

    function selectShape(shapeKey) {
        activeShape.value = shapeKey;
    }


</script>

<style scoped>
.img_box_mod{
    position: relative;
}
.diamond_box {
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
}


h2{
    font-size: 32px;
    font-weight: 400;
    /* text-align: center; */
    color: #212529;
    /* margin-bottom: 15px; */
}
.textbox h2{
    min-height: 65px;
    /* margin-bottom: 2rem; */
}
.info_box p{
    min-height: 100px;
}
.img_box{
    margin: 0 auto;
}
.info_box h3{
    font-size: 24px;
    font-weight: 400;
    text-align: left;
}
.info_box p {
    font-size: 16px;
    font-weight: 400;
    color: #606060;
}

@keyframes slideUpFadeIn {
    0% {
        opacity: 0;
        /* transform: translateY(20px); */
    }
    50%{
        opacity: 0.5;
    }
    100% {
        opacity: 1;
        /* transform: translateY(0); */
    }
}

.info_box {
    opacity: 0;
    transform: translateY(20px);
}

.info_box.active {
    animation: slideUpFadeIn 0.5s ease forwards;
}

.main-content {
    display: flex;
    flex-wrap: wrap;
    align-items: center
}

.img_box, .textbox {
    flex: 1 0 50%;
}

.shape_main {
    flex: 1 1 100%;
}
img {
    max-width: 100%;
    height: auto;
}

.banner_btn {
    display: flex;
}

.banner_btn a {
    padding: 12px 20px;
    margin-right: 3%;
    font-size: 14px;
    min-width: 250px;
    text-align: center;
    color: #353535;
    letter-spacing: 1.5px;
    font-weight: 700;
    text-transform: uppercase;
    border: 1.5px solid #353535;
}

@media (max-width:1150px) {
    .banner_btn {
        gap: 10px 0;
        flex-direction: column;
        /* padding: 0 15%; */
        padding: 0;
    }
    .banner_btn a {
        min-width: 250px;
        margin-right: 0;
}

}

@media (max-width: 767px) {
    .textbox h2{
        min-height: 0px;
        /* margin-bottom: 2rem; */
    }
    h2{
        font-size: 24px;
    }
    .info_box h3{
        font-size: 18px;
    }
    .img_box,
    .textbox {
        text-align: center;
    }    
    .info_box h3 {
        text-align: center;
        font-size: 18px;
        font-weight: 400;
    }
    .main-content {
        flex-direction: column;
    }
    .banner_btn {
        justify-content: center;
        gap: 8px;
        flex-direction: column;
        padding: 16px 15% 0px 15%;
    }
    
    .textbox{
        /* padding: 0 15%; */
    }
    .img_box {
        order: 1;
    }

    .shape_main {
        order: 2;
        width: 100%;
    }

    .textbox {
        order: 3;
        width: 100%;
    }

    .img_box,
    .shape_main,
    .textbox {
        flex: 1 1 100%;
    }

    .info_box p {
        text-align: center;
        font-size: 14px;
        padding: 0 4%;
        min-height: 85px;
    }

}


.largesvg {
    transform: scale(1.3);
}

.modal-content {
  padding: 2%;
  border-radius: 8px;
}
span{
    font-size: 18px;
    text-transform: capitalize;
    font-weight: 600;
    display: block;
    text-align: center;
    color: #212529;
    padding: 5% 0;
}


</style>